import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import PropTypes from 'prop-types';

class UserAvatar extends React.Component {
    static propTypes = {
        PublicUserQuery: PropTypes.shape({
            loading: PropTypes.bool,
            error: PropTypes.object,
            publicUser: PropTypes.object,
          }).isRequired,          
      } 
      
  render () {    
    const cssClass = this.props.className ? this.props.className : ''
    if (this.props.PublicUserQuery.loading) {      
      return (<img alt="placeholder" src="https://cdn.brikl.io/app/loading/placeholder.png" className={"placeholder "+cssClass} />)
    }
    if (this.props.PublicUserQuery.error) {
      console.log(this.props.PublicUserQuery.error)
      return (<div>An unexpected error occurred</div>)
    }    
    return (    	
        <img alt="Avatar" className={cssClass} src={
            this.props.PublicUserQuery.publicUser.avatar?
            this.props.PublicUserQuery.publicUser.avatar
            :'https://cdn.brikl.io/app/error/defaultavatar.png'
        } />                    
    )
  }
}


const publicUser = gql`query publicUser($id:String!){
    publicUser(id:$id){
      id,
      username
      avatar
      name      
    }  
  }`

const UserAvatarData = compose(
    graphql(
        publicUser, {
            name: 'PublicUserQuery',
            options: (ownProps) => ({
                variables: {
                    id: ownProps.userid
                },
                operation: 'query',
            })
        }
    ),
)(UserAvatar)

export default UserAvatarData


// WEBPACK FOOTER //
// ./src/users/UserAvatar.js